import ptr from 'path-to-regexp';
export function createRouteMatcher(path) {
    return ptr(path);
}
//# sourceMappingURL=routes.js.map